export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'USER-ACTION-LOG': {
    TITLE: 'Historial de acciones',
    TABS: {
      CANDIDATES: 'Candidat@s',
      OFFERS_BRANCHES: 'Ofertas y sucursales',
      SAAS_USERS: 'Gestión de usuari@s',
    },
    TABLE: {
      TITLE: 'Historial de acciones',
      TOTAL: '{{total}} registros encontrados',
      CANDIDATES: 'Candidat@s',
      NO_DATA: 'No hay registros de auditoría que coincidan con los filtros aplicados.',
      DELETED_USER: 'Usuari@ eliminad@',
      DELETED_OFFER: 'Oferta eliminada',
      VIEW_DETAIL: 'Ver detalle',
      VIEW_OFFER: 'Ver oferta',
      VIEW_CANDIDATE: 'Ver candidat@',
      TYPE_BULK: 'Masiva',
      TYPE_INDIVIDUAL: 'Individual',
      HEADER: {
        ACTOR: 'Usuari@ empresa',
        TARGET: 'Candidat@',
        ACTION: 'Acción',
        CONTEXT: 'Tipo',
        OFFER: 'Oferta',
        OFFER_PUBLISHED: 'Publicada',
        DATE: 'Fecha y hora',
        ACTIONS: 'Acciones',
        CANDIDATES: 'Candidat@s',
      },
    },
    FILTERS: {
      ACTION: 'Filtrar por acción',
      DATE_FROM: 'Fecha desde',
      DATE_TO: 'Fecha hasta',
      CLEAR: 'Limpiar filtros',
      SEARCH: 'Buscar por mail, oferta...',
    },
    ACTIONS: {
      CHAT: 'Mensaje enviado',
      CANCELLATION: 'Candidat@ movid@ a Descartad@s',
      SELECT: 'Candidat@ movid@ a Finalistas',
      INTERESTING: 'Candidat@ movid@ a Preseleccionad@s',
      RE_SEND_INTERVIEW: 'Entrevista reenviada',
      SEND_INTERVIEW: 'Entrevista enviada',
      ROLLBACK_DISCARD: 'Descarte revertido',
      BACK_TO_REVIEW: 'Candidat@ movid@ a Por revisar',
      SEND_SPECIFIC_QUESTIONS: 'Preguntas específicas enviadas',
      SEND_OFFER_TO_SUGGESTED: 'Oferta enviada a candidat@ sugerid@',
      MESSAGE_DELETE: 'Mensaje eliminado',
      MESSAGE_EDIT: 'Mensaje editado',
      MESSAGE_SEND: 'Mensaje de chat enviado',
      ADD_NOTE: 'Nota añadida',
      NOTE_EDIT: 'Nota editada',
      NOTE_DELETE: 'Nota eliminada',
    },
    CONTEXTS: {
      APPLY_OFFER_ACTION_MULTIPLE: 'Acción masiva sobre candidaturas',
      APPLY_OFFER_ACTION_INDIVIDUAL: 'Acción individual',
      CHAT_MESSAGE_DELETE: 'Eliminación de mensaje',
      CHAT_MESSAGE_EDIT: 'Edición de mensaje',
      CHAT_MESSAGE_SEND: 'Envío de mensaje',
      APPLY_OFFER_NOTE_ADD: 'Nota añadida',
      APPLY_OFFER_NOTE_EDIT: 'Edición de nota',
      APPLY_OFFER_NOTE_DELETE: 'Eliminación de nota',
    },
    DETAIL: {
      TITLE: 'Historial de acciones',
      NOT_FOUND: 'No se encontró este registro de auditoría, o no tienes acceso a él.',
      BACK_TO_LIST: 'Volver al listado',
      SECTION_TITLE: 'Detalle del registro',
      ACTOR: 'Usuari@ empresa',
      TARGET: 'Candidat@',
      ACTION_DETAILS: 'Detalles de la acción',
      METADATA: 'Datos adicionales',
      MESSAGE: 'Mensaje enviado',
      REASON: 'Motivo de descarte',
      NO_REASON: 'Sin motivo especificado',
      QUESTIONS: 'Preguntas enviadas',
      NOTE: 'Nota',
      PREVIOUS_CONTENT: 'Contenido anterior',
      NEW_CONTENT: 'Contenido nuevo',
      GO_TO_OFFER: 'Ver oferta',
      GO_TO_CANDIDATE: 'Ver candidat@',
      TYPE: 'Tipo',
    },
    OFFER_BRANCH: {
      TABLE: {
        HEADER: {
          ACTOR: 'Usuari@',
          ACTION: 'Acción',
          ENTITY_LOCATION: 'Sucursal',
          AFFECTED_OFFERS: 'Oferta',
        },
        OFFERS: 'Ofertas',
      },
      ACTIONS: {
        OFFER_CREATE: 'Oferta creada',
        OFFER_UPDATE: 'Oferta editada',
        OFFER_DELETE: 'Oferta eliminada',
        OFFER_PUBLISH: 'Oferta publicada',
        OFFER_CHANGE_STATUS: 'Estado de oferta cambiado',
        OFFER_PAUSE: 'Oferta pausada',
        OFFER_FINISH: 'Oferta finalizada',
        OFFER_REOPEN: 'Oferta reabierta',
        OFFER_DUPLICATE: 'Oferta duplicada',
        ENTITY_LOCATION_CREATE: 'Sucursal creada',
        ENTITY_LOCATION_UPDATE: 'Sucursal editada',
        ENTITY_LOCATION_DELETE: 'Sucursal eliminada',
      },
      CONTEXTS: {
        OFFER_ACTION: 'Acción sobre oferta',
        ENTITY_LOCATION_ACTION: 'Acción sobre sucursal',
      },
      DETAIL: {
        ENTITY_LOCATION: 'Sucursal',
        STATUS_CHANGE: 'Cambio de estado',
        REASON: 'Motivo',
        SOURCE_OFFER: 'Oferta de origen',
      },
    },
    SAAS_USER: {
      TABLE: {
        HEADER: {
          ACTOR: 'Usuari@ emisor',
          ACTOR_TOOLTIP: 'Usuari@ que ejecuta la acción',
          ACTION: 'Acción',
          TARGET: 'Usuari@ receptor',
          TARGET_TOOLTIP: 'Destinatario de la acción',
          DATE: 'Fecha y hora',
        },
      },
      ACTIONS: {
        SAAS_USER_CREATE: 'Usuari@ dad@ de alta',
        SAAS_USER_DELETE: 'Usuari@ eliminad@',
        SAAS_USER_PERMISSIONS_UPDATE: 'Permisos modificados',
      },
      CONTEXTS: {
        SAAS_USER_ACTION: 'Gestión de usuari@s',
      },
      // Frases completas con parámetros: el orden de las palabras cambia entre idiomas.
      SUMMARY: {
        SAAS_USER_CREATE: '{{actor}} dio de alta a {{target}}',
        SAAS_USER_DELETE: '{{actor}} eliminó a {{target}}',
        SAAS_USER_PERMISSIONS_UPDATE: '{{actor}} cambió los permisos de {{target}}',
      },
      DETAIL: {
        ACTOR: 'Usuari@ emisor',
        TARGET: 'Usuari@ receptor',
        ROLE: 'Rol',
        NO_ROLE: 'Sin rol',
        INITIAL_PERMISSIONS: 'Permisos iniciales',
        BEFORE: 'Antes',
        AFTER: 'Después',
        SCOPED_ROLES: 'Roles por ámbito',
        NO_SCOPED_ROLES: 'Sin roles por ámbito',
        ADDED: 'Añadidos',
        REMOVED: 'Quitados',
        NO_CHANGES: 'Sin cambios en los roles por ámbito',
        // Mostrado cuando no se puede resolver el nombre del ámbito: "Sucursal #10"
        SCOPE_WITH_ID: '{{type}} #{{id}}',
      },
      SCOPE_TYPES: {
        entity: 'Empresa',
        entity_location: 'Sucursal',
        offer: 'Oferta',
      },
      FILTERS: {
        SEARCH: 'Buscar por mail...',
      },
    },
  },
} as const;
